import { lightgray, primaryBlueDark, whiteColor } from 'theme/color';

export const loginContainer = {
  margin: '0px !important',
  padding: '0px, 86px, 0px, 86px',
  maxWidth: '100% !important',
  alignItems: 'flex-start',
};

export const loginLogoContainer = {
  background: primaryBlueDark,
  paddingRight: '5rem',
};

export const imageContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
};

export const messageText = {
  // paddingLeft: "5rem",
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: '700',
  textAlign: 'right',
  color: '#FFFFFF',
  width: '100%',
  // height:"399px",
  lineHeight: '72px',
  // marginTop: "4rem",
  flex: 'none',
  letterSpacing: '0px',
};

export const loginBkgrd = {
  background: `${lightgray} !important`,
  height: '100%',
  width: '100%',
};
export const loginInfo = {
  display: 'flex',
};
